import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BtnTheme } from '../../type/btnTheme.type';
import { FontWeight } from '../../type/fontWeight.type';
import { BtnType } from '../../type/btnType.type';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-raised-btn',
  templateUrl: './raised-btn.component.html',
  styleUrls: ['./raised-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RaisedBtnComponent {
  @Input('color') color: ThemePalette;
  @Input('text') text: string = 'Placeholder';
  @Input('theme') theme: BtnTheme;
  @Input('uppercase') uppercase: boolean = true;
  @Input('disabled') disabled: boolean = false;
  @Input('fontWeight') fontWeight: FontWeight = 400;
  @Input('type') type: BtnType = 'button';
}